export const GET_PRODUCT_GET_CART_COUNT_DATA= "GGET_PRODUCT_GET_CART_COUNT_DATA";
export const GET_PRODUCT_GET_CART_COUNT_DATA_ERROR = "GET_PRODUCT_GET_CART_COUNT_DATA_ERROR";
export const GET_PRODUCT_GET_CART_COUNT_DATA_SUCCESS = "GET_PRODUCT_GET_CART_COUNT_DATA_SUCCESS";